<script>
export default {
  data() {
    return {
      show: false,
      ifarmeUrl: ''
    }
  },
  methods: {
    display(event) {
      this.show = true
      if (event.type === '1') {
        this.ifarmeUrl = `https://platform.wechain360.com/share/sys_tenant_shop/tenant_shop_share/${event.data.uuid}/906`
      } else if (event.type === '0') {
        this.ifarmeUrl = `https://platform.wechain360.com/share/sys_shop/platform_shop_share/${event.data.uuid}/906`
      } else if (event.type === '2') {
        this.ifarmeUrl = `https://platform.wechain360.com/share/sys_park_shop/park_shop_share/${event.data.uuid}/906`
      }
    }
  }
}
</script>

<template>
  <el-drawer :visible.sync="show" title="详情" size="90%">
    <div style="width: 100%; height: 100%; padding: 20px; box-sizing: border-box;">
      <iframe :src="ifarmeUrl" frameborder="0" style="width: 100%; height: 99%;"></iframe>
    </div>
  </el-drawer>
</template>